import { MailCheck, ArrowRight, RotateCw } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';

export const VerificationForm = ({ email, code, setCode, busy, seconds, onSubmit, onResend, onBack }) => (
  <div className="signup-verification" data-testid="signup-verification-panel">
    <MailCheck size={32} className="text-emerald-500 mb-4" aria-hidden="true" />
    <p data-testid="signup-verification-email" className="break-all mb-6">{email}</p>
    <form onSubmit={onSubmit} data-testid="signup-verify-form" className="space-y-5">
      <div>
        <Label htmlFor="signup-code" data-testid="signup-code-label">Баталгаажуулах код</Label>
        <Input id="signup-code" data-testid="signup-code-input" inputMode="numeric" autoComplete="one-time-code"
          pattern="[0-9]{6}" minLength={6} maxLength={6} required autoFocus
          value={code} disabled={busy} onChange={event => setCode(event.target.value.replace(/\D/g, '').slice(0, 6))} />
      </div>
      <Button data-testid="signup-verify-button" type="submit" disabled={busy || code.length !== 6}
        className="signup-primary w-full">{busy ? 'Шалгаж байна…' : 'Баталгаажуулах'}<ArrowRight size={18} /></Button>
    </form>
    <div className="mt-5 flex flex-wrap items-center justify-between gap-3">
      <Button data-testid="signup-resend-button" variant="ghost" type="button" disabled={busy || seconds > 0}
        onClick={onResend}><RotateCw size={16} />{seconds > 0 ? `Дахин илгээх (${seconds})` : 'Код дахин илгээх'}</Button>
      <Button data-testid="signup-change-email-button" variant="ghost" type="button" disabled={busy}
        onClick={onBack}>Email солих</Button>
    </div>
  </div>
);